/*
 * Display names for the identification ensemble's models and for the external
 * reference sets its k-NN bank is built from. These are proper names (the same
 * in Hebrew and English), so they are not catalogue entries. The keys are the
 * service's own (backend/ai/ensemble.py MODEL_REGISTRY, routes/photos.py
 * REFERENCE_SOURCES); an unknown key is shown as it came.
 */
export const MODEL_NAMES = Object.freeze({
  bioclip: 'BioCLIP',
  convnext_df20: 'ConvNeXt (DF20)',
  vit_df20: 'ViT (DF20)',
  effnetv2: 'EfficientNetV2',
});

export const REFERENCE_SOURCE_NAMES = Object.freeze({
  df20: 'DF20 (Danish Fungi 2020)',
  inaturalist: 'iNaturalist',
  mushroomobserver: 'Mushroom Observer',
});

export const modelName = key => MODEL_NAMES[key] || key;
export const sourceName = key => REFERENCE_SOURCE_NAMES[key] || key;

/** Keys in a stable order: the known ones first, as listed above, then the rest. */
export function orderedKeys(keys, known) {
  const order = Object.keys(known);
  const rank = k => (order.includes(k) ? order.indexOf(k) : order.length);
  return [...new Set(keys)].sort((a, b) => rank(a) - rank(b) || a.localeCompare(b));
}
